import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { unionBy as _unionBy } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { env } from '@amfam/environment';
import { Coverage, PolicySummary, PropertyPolicy } from '@amfam/policy/models';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import {
  Applications,
  ApplicationService,
  CopyService
} from '@amfam/shared/utility/shared-services';

import { TypedWorker } from './typed-worker';

@Injectable({
  providedIn: 'root'
})
export class PlpropertyService implements TypedWorker {
  constructor(
    private http: HttpClient,
    private copyService: CopyService,
    private featureFlag: FeatureFlagService,
    private applicationService: ApplicationService
  ) {}

  public getEndpoint() {
    if (
      this.featureFlag.isEnabled('policy_experience_api') &&
      !this.applicationService.isApp(Applications.FIRST_PARTY_FNOL)
    ) {
      return env.policyExperienceApi + 'propertypolicies/';
    } else {
      return env.productApi + 'propertypolicies/';
    }
  }

  /*
    Expectation is that this will take the shape of the plauto api and have a status object
    and a policy object
  */
  public getPolicy(url: string, policySummary: PolicySummary): Observable<PropertyPolicy> {
    return this.http.get(url).pipe(map((data: unknown) => this.loadModel(data, policySummary)));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public loadModel(json: any, policySummary: PolicySummary): PropertyPolicy {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let policy: any = json;
    if (json.policy) {
      policy = json.policy;
    }
    policy.namedInsuredList = [];

    if (policy.policyRoles) {
      for (let i = 0; i < policy.policyRoles.length; i++) {
        const name = policy.policyRoles[i].name;
        policy.namedInsuredList.push(name);
      }
    }

    return PropertyPolicy.fromJson(
      { ...policy, sourceSystem: policySummary.sourcePath },
      this.getCoveragesToFilter(),
      this.getCoveragesToReplace()
    );
  }

  getCoveragesToFilter() {
    return this.copyService.getCopy('policy.filterCoverages');
  }

  getCoveragesToReplace() {
    return this.copyService.getCopy('policy.replaceCoverages');
  }

  public getPolicyLevelCoverages(policy: PropertyPolicy): Array<Coverage> {
    return _unionBy(policy.policyCoverages, policy.propertyCoverages, x => x.code);
  }
}
